import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "../CSS/Frame.css";
import { publicSites } from "../utils/GlobalContext";
import { getCopyRight } from "../utils/tools";
import { useEffect, useRef, useState } from "react";


export default function Frame({ currentPath, content }) {
  let redirectPath = useNavigate();
  const headerMenu = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [fadingEdgeClass, setFadingEdgeClass] = useState("");

  function setFadingClass() {
    if (headerMenu.current) {
      const { scrollLeft, scrollWidth, clientWidth } = headerMenu.current;
      if (scrollLeft > 0) setFadingEdgeClass("head-menu-left");
      else if (scrollLeft < scrollWidth - clientWidth) setFadingEdgeClass("head-menu-right");
      else setFadingEdgeClass("head-menu");
    } else {
      setFadingEdgeClass("");
    }
  }

  const handleDown = (e) => {
    if (headerMenu.current) {
      setIsDragging(true);
      const pageX = e.touches ? e.touches[0].pageX : e.pageX;
      setStartX(pageX - headerMenu.current.offsetLeft);
      setScrollLeft(headerMenu.current.scrollLeft);
    }
  }

  const handleMove = (e) => {
    if (headerMenu.current && isDragging) {
      e.preventDefault();
      const pageX = e.touches ? e.touches[0].pageX : e.pageX;
      const x = pageX - headerMenu.current.offsetLeft;
      const walk = (x - startX) * 2;  // scroll speed
      headerMenu.current.scrollLeft = scrollLeft - walk;
    }
    setFadingClass()
  }

  const handleLeave = (e) => {
    setIsDragging(false);
  }

  useEffect(() => {
    setFadingClass();
    window.addEventListener("resize", setFadingClass, false);
  }, []);

  function prepareButtonList() {
    const navigation = [];
    for (var key in publicSites) {
      let config = publicSites[key];
      if (config.path === currentPath) {
        navigation.push(<Button key={key} color="primary"
          variant="text"
          className="selected-header-menu"
          onClick={() => redirectPath(config.path)}
          size="large"
          sx={{ fontWeight: 700, color: "white", minWidth: "fit-content" }}
        >
          {config.name}
        </Button>);
      } else {
        navigation.push(<Button key={key}
          variant="text"
          color="grey"
          onClick={() => redirectPath(config.path)}
          size="large"
          sx={{ fontWeight: 400, minWidth: "fit-content" }}
        >
          {config.name}
        </Button>);
      }
      navigation.push(<Box className="frame-border-divider" key={key + '1'} />)
    }
    navigation.pop();
    return navigation;
  }

  return (
    <>
      <Box className="header-bar">
        <div ref={headerMenu} className={`head-menu ${fadingEdgeClass}`}
          onMouseDown={handleDown}
          onMouseMove={handleMove}
          onMouseLeave={handleLeave}
          onMouseUp={handleLeave}
          onTouchStart={handleDown}
          onTouchMove={handleMove}
          onTouchEnd={handleLeave}
          style={{ cursor: isDragging ? "grabbing" : "grab" }}
        >
          {prepareButtonList()}
        </div>
      </Box>
      <Box className="content-body">
        {content}
      </Box>
      <Box className="flex-row">
        <Typography fontSize={"1rem"} color={"grey"} mt="2rem">
          {getCopyRight()}
        </Typography>
      </Box>
    </>);
}